import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IPostEditState {
  postToEditId: number | null;
  postToEditPlaceOfUse: 'post_modal' | 'activity_feed' | null;
}

const initialState: IPostEditState = {
  postToEditId: null,
  postToEditPlaceOfUse: null,
};

export const postEditStateSlice = createSlice({
  name: 'postEditState',
  initialState,
  reducers: {
    onSetPostToEditState: (
      state,
      action: PayloadAction<{
        id: number;
        placeOfUse: 'post_modal' | 'activity_feed';
      } | null>
    ) => {
      if (!action.payload) {
        return initialState;
      }

      const { id, placeOfUse } = action.payload;

      state.postToEditId = id;
      state.postToEditPlaceOfUse = placeOfUse;
    },
  },
});

export const { onSetPostToEditState } = postEditStateSlice.actions;

export default postEditStateSlice.reducer;
